import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import { useService } from 'hooks';
import { UserOptionService } from 'services';
import { Spinner, TitledBox } from 'components';
import Tools from 'utils/Tools';

import ListOptions from '../ListOptions';

const { getUserOptions, updateUserOptions } = UserOptionService;

const UserListOptions = () => {
	const [loading, setLoading] = useState(true);
	const [userOptions, setUserOptions] = useState(null);
	const { enqueueSnackbar } = useSnackbar();
	const { callService, isProcessing } = useService();

	useEffect(() => {
		if (loading) {
			getUserOptions()
				.then(({ data }) => {
					setUserOptions(data);
				})
				.catch(console.log)
				.finally(() => {
					setLoading(false);
				});
		}
	}, [loading]);

	const handleSubmit = (values) => {
		callService(updateUserOptions(values))
			.then(({ data }) => {
				enqueueSnackbar(data?.message || 'Éxito', { variant: data.messageType });
			})
			.catch((error) => {
				enqueueSnackbar(Tools.getErrorMessage(error), { variant: 'error' });
			});
	};

	if (loading)
		return (
			<TitledBox title="Listados" style={{ maxWidth: 566 }}>
				<Spinner small text="Cargando listados" />
			</TitledBox>
		);

	return (
		<>
			{userOptions?.length > 0 && <ListOptions options={userOptions} onFinish={handleSubmit} />}
			{isProcessing && <Spinner isOpen text="Guardando listados" />}
		</>
	);
};

export default UserListOptions;
